import { lazy } from 'react';

export const PrivateCabinetAsync = lazy(async () => import('./PrivateCabinet'));
